(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewCountPattern = /\s*\(\s*\d+\s*\)\s*$/;
    const observedRoots = new WeakSet();

    const removeReviewCount = (root) => {
      if (!root) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((node) => {
        const value = node.nodeValue || '';

        if (reviewCountPattern.test(value)) {
          node.nodeValue = value.replace(reviewCountPattern, '');
        }
      });

      root.querySelectorAll?.('*').forEach((element) => {
        if (element.shadowRoot) {
          observeRoot(element.shadowRoot);
        }
      });
    };

    const observeRoot = (root) => {
      if (!root || observedRoots.has(root)) return;

      observedRoots.add(root);
      removeReviewCount(root);

      const observer = new MutationObserver(() => removeReviewCount(root));
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    };

    const initializeRatingWidgets = () => {
      document
        .querySelectorAll('.etrusted-card-rating etrusted-widget')
        .forEach((widget) => {
          observeRoot(widget);

          if (widget.shadowRoot) {
            observeRoot(widget.shadowRoot);
          }
        });
    };

    initializeRatingWidgets();

    const documentObserver = new MutationObserver(initializeRatingWidgets);
    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-article-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('szh-article-reader')) {
  class SzhArticleReader extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const start = () => { if (this.isConnected) this.setup(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.events.signal });
      else start();
    }
    disconnectedCallback() {
      this.events?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    normalise(text) { return text.toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
    setup() {
      const body = this.querySelector('[data-article-body]');
      if (!body) return;
      const initial = !this.dataset.enhanced;
      if (initial) {
        const all = [...body.querySelectorAll('h2,h3')];
        all.forEach((h, index) => {
          if (h.id && document.getElementById(h.id) === h) return;
          const base = this.normalise(h.textContent).replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-') || `section-${index + 1}`;
          let id = base, n = 2;
          while (document.getElementById(id)) id = `${base}-${n++}`;
          h.id = id;
        });
        if (this.dataset.summary === 'true') {
          const h = [...body.querySelectorAll('h2')].find(el => /^(w skrocie|najwazniejsze informacje)/.test(this.normalise(el.textContent)));
          if (h) {
            let cursor = h.nextSibling, list = null, nodes = [h];
            for (let n = 0; cursor && n < 12; n++) {
              if (cursor.nodeType === 1 && /^(H[1-6]|SECTION|DIV|IMG|FIGURE)$/.test(cursor.tagName)) break;
              nodes.push(cursor);
              if (cursor.nodeType === 1 && /^(UL|OL)$/.test(cursor.tagName)) { list = cursor; break; }
              cursor = cursor.nextSibling;
            }
            if (list) {
              const box = document.createElement('section');
              box.className = 'sa-summary';
              box.setAttribute('aria-labelledby', h.id);
              nodes.forEach(node => box.append(node));
              this.querySelector('[data-summary-slot]').append(box);
            }
          }
        }
        if (this.dataset.accordion === 'true') {
          [...body.querySelectorAll('h2')].filter(h => /^faq(?:\s|:|$)/.test(this.normalise(h.textContent))).forEach(h => {
            let cursor = h.nextSibling, answer = null;
            while (cursor) {
              if (cursor.nodeType === 1 && /^(H1|H2)$/.test(cursor.tagName)) break;
              const next = cursor.nextSibling;
              if (cursor.nodeType === 1 && cursor.tagName === 'H3') {
                const details = document.createElement('details'), summary = document.createElement('summary'), plus = document.createElement('span');
                details.className = 'sa-faq-item';
                plus.textContent = '+'; plus.setAttribute('aria-hidden', 'true');
                cursor.before(details); summary.append(cursor, plus); answer = document.createElement('div'); answer.className = 'sa-faq-answer'; details.append(summary, answer);
              } else if (answer) answer.append(cursor);
              cursor = next;
            }
          });
        }
        if (this.dataset.sources === 'true') {
          [...body.querySelectorAll('h2')].filter(h => /^(zrodla|bibliografia)(?:\s|:|$)/.test(this.normalise(h.textContent))).forEach(h => {
            const nodes = []; let cursor = h.nextSibling;
            while (cursor && !(cursor.nodeType === 1 && /^(H1|H2)$/.test(cursor.tagName))) { nodes.push(cursor); cursor = cursor.nextSibling; }
            if (!nodes.length) return;
            const details = document.createElement('details'), summary = document.createElement('summary'), content = document.createElement('div'), plus = document.createElement('span');
            details.className = 'sa-sources'; content.className = 'sa-sources-content'; plus.textContent = '+'; plus.setAttribute('aria-hidden', 'true');
            h.before(details); summary.append(h, plus); content.append(...nodes); details.append(summary, content);
          });
        }
        body.querySelectorAll('table').forEach(table => {
          const wrapper = document.createElement('div'); wrapper.className = 'sa-table-scroll'; wrapper.tabIndex = 0; wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', this.dataset.tableLabel); table.before(wrapper); wrapper.append(table);
        });
        body.querySelectorAll('img').forEach(img => {
          if (img.closest('a,button')) return;
          const button = document.createElement('button'); button.type = 'button'; button.className = 'sa-image-zoom'; button.dataset.zoomImage = ''; button.setAttribute('aria-label', this.dataset.zoomLabel); img.before(button); button.append(img);
        });
        const cta = this.querySelector('[data-inline-collection]');
        const sections = [...body.querySelectorAll('h2')].filter(h => !h.closest('details,[data-meta-faq]') && !/^(faq|zrodla|bibliografia|podsumowanie)/.test(this.normalise(h.textContent)));
        if (cta && sections.length >= 4) sections[3].before(cta);
        this.dataset.enhanced = 'true';
      }
      const details = this.querySelector('[data-toc-details]'), list = this.querySelector('[data-toc-list]');
      const headings = [...this.querySelector('.sa-reading-column').querySelectorAll('h2')];
      if (this.dataset.toc === 'true' && headings.length >= 3) {
        list.replaceChildren();
        headings.forEach(h => { const li = document.createElement('li'), a = document.createElement('a'); a.href = `#${h.id}`; a.textContent = h.textContent.trim(); li.append(a); list.append(li); });
        this.querySelector('[data-toc-aside]').hidden = false; this.dataset.hasToc = '';
        const media = matchMedia('(min-width:1050px)');
        const resizeToc = () => { details.open = media.matches; };
        resizeToc(); media.addEventListener('change', resizeToc, { signal: this.events.signal });
        let active = -1;
        const update = () => {
          this.frame = null;
          const top = parseInt(getComputedStyle(this).getPropertyValue('--sa-sticky'), 10) || 170;
          let next = 0; headings.forEach((h, i) => { if (h.getBoundingClientRect().top <= top + 30) next = i; });
          if (next !== active) { [...list.querySelectorAll('a')].forEach((a, i) => { if (i === next) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); }); active = next; }
        };
        const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', schedule, { passive: true, signal: this.events.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: this.events.signal }); update();
      }
      const dialog = this.querySelector('[data-image-dialog]');
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom-image]');
        if (zoom && typeof dialog.showModal === 'function') {
          const source = zoom.querySelector('img'), img = document.createElement('img'); img.src = source.currentSrc || source.src; img.alt = source.alt; this.querySelector('[data-dialog-image]').replaceChildren(img); this.zoomTrigger = zoom; dialog.showModal();
        }
        if (event.target.closest('[data-close-dialog]') || event.target === dialog) dialog.close();
      }, { signal: this.events.signal });
      dialog.addEventListener('close', () => this.zoomTrigger?.focus(), { signal: this.events.signal });
      const revealHash = () => {
        if (!location.hash) return;
        let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id); if (!target || !this.contains(target)) return;
        let parent = target.parentElement; while (parent && parent !== this) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; }
        requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      };
      window.addEventListener('hashchange', revealHash, { signal: this.events.signal }); revealHash();
    }
  }
  customElements.define('szh-article-reader', SzhArticleReader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-b2b-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const toggle = event.target.closest('[data-szh-b2b-expand]');
  if (toggle) {
    const panel = toggle.closest('[data-szh-b2b-viewer]');
    if (!panel) return;
    const expanded = panel.classList.toggle('szh-b2b__viewer--expanded');
    document.documentElement.classList.toggle('szh-b2b-preview-open', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.setAttribute('aria-label', expanded ? 'Zamknij duży podgląd katalogu' : 'Powiększ katalog bez opuszczania strony');
    const label = toggle.querySelector('[data-szh-b2b-expand-label]');
    if (label) label.textContent = expanded ? 'Zamknij podgląd' : 'Powiększ katalog';
    const icon = toggle.querySelector('.szh-b2b__viewer-toggle-icon');
    if (icon) icon.textContent = expanded ? '×' : '⤢';
    if (expanded) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Powiększony podgląd katalogu B2B');
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-label');
    }
    toggle.focus();
    return;
  }
  const selected = event.target.closest('[data-szh-b2b-select]');
  if (!selected) return;
  const root = selected.closest('.szh-b2b');
  if (!root) return;
  const viewer = root.querySelector('[data-szh-b2b-viewer]');
  const iframe = root.querySelector('[data-szh-b2b-frame]');
  const heading = root.querySelector('[data-szh-b2b-title]');
  const url = selected.getAttribute('data-url');
  const label = selected.getAttribute('data-label') || 'Katalog B2B';
  if (!viewer || !iframe || !url) return;
  root.querySelectorAll('[data-szh-b2b-select]').forEach(function(item) {
    item.setAttribute('aria-pressed', item === selected ? 'true' : 'false');
  });
  if (heading) heading.textContent = label;
  iframe.setAttribute('title', 'Podgląd katalogu: ' + label);
  if (iframe.getAttribute('src') !== url) iframe.setAttribute('src', url);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  viewer.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'start'});
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const expanded = document.querySelector('.szh-b2b__viewer--expanded');
  if (!expanded) return;
  const close = expanded.querySelector('[data-szh-b2b-expand]');
  if (close) {
    event.preventDefault();
    close.click();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-collection-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('szh-collection-seo')) {
  class SzhCollectionSeo extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('.szh-collection-faq__source');
      const target = this.querySelector('[data-faq-items]');
      if (!source || !target || source.dataset.enhanced === 'true') return;
      const questions = [...source.querySelectorAll('h4')];
      if (!questions.length) return;
      questions.forEach((heading) => {
        const details = document.createElement('details');
        details.className = 'szh-collection-faq__item';
        const summary = document.createElement('summary');
        const title = document.createElement('h3');
        title.className = 'szh-collection-faq__question';
        title.innerHTML = heading.innerHTML;
        const plus = document.createElement('span');
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summary.append(title, plus);
        const answer = document.createElement('div');
        answer.className = 'szh-collection-faq__answer';
        let node = heading.nextElementSibling;
        while (node && !['H2','H3','H4'].includes(node.tagName)) {
          const next = node.nextElementSibling;
          answer.appendChild(node.cloneNode(true));
          node = next;
        }
        details.append(summary, answer);
        target.appendChild(details);
      });
      source.dataset.enhanced = 'true';
      source.classList.add('is-enhanced');
    }
  }
  customElements.define('szh-collection-seo', SzhCollectionSeo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-contact-form"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('szh-contact-form')) {
  class SzhContactForm extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-reason]');
      if (!select) return;
      this.classList.add('is-enhanced');
      const update = () => {
        const option = select.selectedOptions[0];
        const order = this.querySelector('[data-conditional="order"]');
        const product = this.querySelector('[data-conditional="product"]');
        if (order) order.hidden = option?.dataset.order !== 'true';
        if (product) product.hidden = option?.dataset.product !== 'true';
      };
      select.addEventListener('change', update);
      update();
      const form = this.querySelector('form');
      const button = this.querySelector('[data-submit]');
      const consent = this.querySelector('[data-consent]');
      const consentError = this.querySelector('[data-consent-error]');

      if (consent) {
        const errorMessage = consent.dataset.errorMessage || 'Aby wysłać formularz, zaznacz powyższą zgodę.';

        consent.addEventListener('invalid', () => {
          consent.setCustomValidity(errorMessage);
          consent.setAttribute('aria-invalid', 'true');
          if (consentError) consentError.hidden = false;
        });

        consent.addEventListener('change', () => {
          if (consent.checked) {
            consent.setCustomValidity('');
            consent.removeAttribute('aria-invalid');
            if (consentError) consentError.hidden = true;
          }
        });
      }

      form?.addEventListener('submit', () => {
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
      });
      this.querySelector('[data-success]')?.focus();
    }
  }
  customElements.define('szh-contact-form', SzhContactForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-faq-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = (value) => value
    .toLocaleLowerCase('pl-PL')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const init = (section) => {
    if (!section || section.dataset.szhFaqBound === 'true') return;
    section.dataset.szhFaqBound = 'true';

    const root = section.querySelector('[data-szh-faq-root]');
    const input = section.querySelector('[data-szh-faq-search]');
    const clear = section.querySelector('[data-szh-faq-clear]');
    const empty = section.querySelector('[data-szh-faq-empty]');
    if (!root || !input) return;

    const items = [...root.querySelectorAll('[data-szh-faq-item]')];
    const groups = [...root.querySelectorAll('[data-szh-faq-group]')];

    const applyFilter = () => {
      const query = normalize(input.value);
      let totalVisible = 0;

      items.forEach((item) => {
        const haystack = normalize(item.dataset.searchText || item.textContent || '');
        const visible = query === '' || haystack.includes(query);
        item.hidden = !visible;
        if (visible) totalVisible += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-szh-faq-item]:not([hidden])');
      });

      if (clear) clear.hidden = query === '';
      if (empty) empty.hidden = totalVisible > 0;
    };

    input.addEventListener('input', applyFilter);
    clear?.addEventListener('click', () => {
      input.value = '';
      applyFilter();
      input.focus();
    });

    if (root.dataset.oneAtATime === 'true') {
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    applyFilter();
  };

  const initAll = () => document.querySelectorAll('.szh-faq').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szh-promotions-grid-split"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewCountPattern = /\s*\(\s*\d+\s*\)\s*$/;
    const observedRoots = new WeakSet();

    const removeReviewCount = (root) => {
      if (!root) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((node) => {
        const value = node.nodeValue || '';

        if (reviewCountPattern.test(value)) {
          node.nodeValue = value.replace(reviewCountPattern, '');
        }
      });

      root.querySelectorAll?.('*').forEach((element) => {
        if (element.shadowRoot) {
          observeRoot(element.shadowRoot);
        }
      });
    };

    const observeRoot = (root) => {
      if (!root || observedRoots.has(root)) return;

      observedRoots.add(root);
      removeReviewCount(root);

      const observer = new MutationObserver(() => removeReviewCount(root));
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    };

    const initializeRatingWidgets = () => {
      document
        .querySelectorAll('.etrusted-card-rating etrusted-widget')
        .forEach((widget) => {
          observeRoot(widget);

          if (widget.shadowRoot) {
            observeRoot(widget.shadowRoot);
          }
        });
    };

    initializeRatingWidgets();

    const documentObserver = new MutationObserver(initializeRatingWidgets);
    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
